var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WindowFrame',{staticClass:"ma-0 pa-0",attrs:{"component":'sched',"input_args":_vm.input_args}})
}
var staticRenderFns = []

export { render, staticRenderFns }